"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.classNames = void 0;
const classNames = (...names) => {
    const attachments = [];
    for (const name of names) {
        if (!name) {
            continue;
        }
        if (typeof name === 'string') {
            attachments.push(name);
        }
        else if (typeof name === 'object') {
            attachments.push(...Object.entries(name).map(([key, value]) => value ? key : undefined));
        }
    }
    return attachments
        .filter(Boolean)
        .map((values) => values?.replace(new RegExp(/[\s]{1,}/, 'g'), '-') ?? '');
};
exports.classNames = classNames;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY2xhc3NuYW1lcy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9wYWNrYWdlcy9zaGFyZWQvY2xhc3NuYW1lcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFFTyxNQUFNLFVBQVUsR0FBRyxDQUFDLEdBQUcsS0FBb0IsRUFBWSxFQUFFO0lBQzlELE1BQU0sV0FBVyxHQUEyQixFQUFFLENBQUM7SUFFL0MsS0FBSyxNQUFNLElBQUksSUFBSSxLQUFLLEVBQUU7UUFDeEIsSUFBSSxDQUFDLElBQUksRUFBRTtZQUNULFNBQVM7U0FDVjtRQUVELElBQUksT0FBTyxJQUFJLEtBQUssUUFBUSxFQUFFO1lBQzVCLFdBQVcsQ0FBQyxJQUFJLENBQUMsSUFBSSxDQUFDLENBQUM7U0FDeEI7YUFBTSxJQUFJLE9BQU8sSUFBSSxLQUFLLFFBQVEsRUFBRTtZQUNuQyxXQUFXLENBQUMsSUFBSSxDQUNkLEdBQUcsTUFBTSxDQUFDLE9BQU8sQ0FBQyxJQUFJLENBQUMsQ0FBQyxHQUFHLENBQUMsQ0FBQyxDQUFDLEdBQUcsRUFBRSxLQUFLLENBQUMsRUFBRSxFQUFFLENBQzNDLEtBQUssQ0FBQyxDQUFDLENBQUMsR0FBRyxDQUFDLENBQUMsQ0FBQyxTQUFTLENBQ3hCLENBQ0YsQ0FBQztTQUNIO0tBQ0Y7SUFFRCxPQUFPLFdBQVc7U0FDZixNQUFNLENBQUMsT0FBTyxDQUFDO1NBQ2YsR0FBRyxDQUFDLENBQUMsTUFBTSxFQUFFLEVBQUUsQ0FBQyxNQUFNLEVBQUUsT0FBTyxDQUFDLElBQUksTUFBTSxDQUFDLFVBQVUsRUFBRSxHQUFHLENBQUMsRUFBRSxHQUFHLENBQUMsSUFBSSxFQUFFLENBQUMsQ0FBQztBQUM5RSxDQUFDLENBQUM7QUF0QlcsUUFBQSxVQUFVLGNBc0JyQiJ9